module.exports = __webpack_public_path__ + "static/media/新智能机械臂-PNG.53ce6f74.png";